import { Link } from 'react-router-dom';

export default function CtaSection() {
  return (
    <section className="relative py-16 md:py-20 overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Abstract%20warm%20gradient%20background%20with%20flowing%20golden%20and%20amber%20waves%2C%20cinematic%20glow%20effects%2C%20elegant%20modern%20design%2C%20luxurious%20texture%2C%20soft%20warm%20light%20streaks%2C%20dark%20rich%20undertones&width=1920&height=600&seq=cta-bg-home&orientation=landscape"
          alt=""
          className="w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-foreground-900/90 to-foreground-900/70"></div>
      </div>

      <div className="container-custom relative z-10 text-center">
        <h2 className="text-2xl md:text-4xl font-heading text-background-50 mb-4">
          海量精彩内容，等你来发现
        </h2>
        <p className="text-sm md:text-base text-background-300 max-w-lg mx-auto mb-8">
          无需注册，无需付费，打开即看。福利视频在线持续为您提供最新最热的视频资源。
        </p>
        <div className="flex flex-col sm:flex-row items-center gap-3 justify-center">
          <Link
            to="/category/dianshiju"
            className="w-full sm:w-auto px-8 py-3 bg-primary-500 text-background-50 rounded-full font-medium text-sm hover:bg-primary-600 transition-all duration-300 whitespace-nowrap text-center"
          >
            <i className="ri-play-circle-line mr-2"></i>
            开始观看
          </Link>
          <Link
            to="/about"
            className="w-full sm:w-auto px-8 py-3 border border-background-300/50 text-background-50 rounded-full font-medium text-sm hover:bg-background-50/10 transition-all duration-300 whitespace-nowrap text-center"
          >
            <i className="ri-information-line mr-2"></i>
            了解我们
          </Link>
        </div>
      </div>
    </section>
  );
}